import GiftCardIcon from '../../assets/GiftCardIcon.svg';
import CharityIcon from '../../assets/CharityIcon.svg';
import PayPalIcon from '../../assets/PayPalIcon.svg';
import VenmoIcon from '../../assets/VenmoIcon.svg';
import { CHARITY, GIFT_CARDS, PAY_PAL, VENMO } from '../pages';
import {
  CashoutProviderButtons_providers$key,
  CashoutProviderButtons_providers$data,
  CashoutMethod,
} from './__generated__/CashoutProviderButtons_providers.graphql';
import useLiveFragment from 'relay/useLiveFragment';
import React from 'react';
import CashoutProviderButton, {
  Props as CashoutProviderButtonProps,
} from './CashoutProviderButton';
import CashoutProviderInfoModal from './CashoutProviderInfoModal';
import classes from './CashoutProviderButtons.module.scss';
import { graphql } from 'react-relay';
import clsx from 'clsx';

export type CashoutProviderData = Omit<
  CashoutProviderButtonProps,
  'provider' | 'onLockedClick' | 'status'
>;
export const CASHOUT_PROVIDER_DATA: Record<CashoutMethod, CashoutProviderData> = {
  PAYPAL: {
    path: PAY_PAL.path,
    Icon: PayPalIcon,
    name: 'PayPal',
  },
  VENMO: {
    path: VENMO.path,
    Icon: VenmoIcon,
    name: 'Venmo',
  },
  GIFT_CARD: {
    path: GIFT_CARDS.path,
    Icon: GiftCardIcon,
    name: 'Gift Cards',
  },
  CHARITY: {
    path: CHARITY.path,
    Icon: CharityIcon,
    name: 'Charity',
  },
};

const fragmentSpec = graphql`
  fragment CashoutProviderButtons_providers on CashoutProviders
  @refetchable(queryName: "CashoutProvidersRefetchQuery") {
    providers {
      name
      status
    }
  }
`;
export interface Props {
  cashoutProvidersRef: CashoutProviderButtons_providers$key;
  className?: string;
}
export type CashoutProvider = CashoutProviderButtons_providers$data['providers'][number];
export default function CashoutProviderButtons({ cashoutProvidersRef, className }: Props) {
  const providers: CashoutProviderButtons_providers$data = useLiveFragment(
    fragmentSpec,
    cashoutProvidersRef,
  );

  const sortedCashoutProviders = [...providers.providers].sort((a, b) =>
    a.status === 'OFFLINE' && b.status !== 'OFFLINE' ? 1 : 0,
  );

  const [infoModalProvider, setInfoModalProvider] = React.useState<CashoutProvider | null>(null);
  return (
    <>
      <div className={clsx(classes.cashoutLinks, className)}>
        {sortedCashoutProviders.map((provider: CashoutProvider) => (
          <CashoutProviderButton
            key={provider.name}
            {...CASHOUT_PROVIDER_DATA[provider.name]}
            status={provider.status}
            onLockedClick={() => setInfoModalProvider(provider)}
          />
        ))}
      </div>
      {infoModalProvider && (
        <CashoutProviderInfoModal
          provider={infoModalProvider}
          name={CASHOUT_PROVIDER_DATA[infoModalProvider.name].name}
          onClose={() => setInfoModalProvider(null)}
        />
      )}
    </>
  );
}
